import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '@/store/global/globalState';
import { RootState } from '@/store';

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isSidebarOpen = action.payload;
    },
  },
});

export const { toggleSidebar, setSidebarOpen } = globalSlice.actions;

export const selectIsSidebarOpen = (state: RootState) =>
  state.global.isSidebarOpen;

export default globalSlice.reducer;
